export default "__VITE_ASSET__CljPI8fm__"